import styled from "styled-components";
import { Colors } from "../../colors/Colors";

export const Page = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-inline: 1.5rem;
  background-color: ${Colors.white};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  max-width: 1216px;
  width: 100%;
  margin-top: 5rem;
  padding-bottom: 10rem;

  @media (max-width: 600px) {
    margin-top: 2rem;
    padding-bottom: 4rem;
    gap: 1.5rem;
  }
`;

export const Header = styled.h1`
  && {
    color: ${Colors.accent1};
    font-family: "Poppins", sans-serif !important;
    font-size: 48px;
    font-weight: 900;
    margin-bottom: 0;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 36px;
    }

    @media (max-width: 600px) {
      font-size: 32px;
    }
  }
`;

export const Text = styled.p`
  && {
    color: ${Colors.accent1};
    font-family: "Roboto", sans-serif !important;
    font-size: 18px;
    font-weight: 400;
    text-align: center;
    max-width: 672px;
    margin-top: 0;

    @media (max-width: 600px) {
      font-size: 16px;
    }
  }
`;

export const SeoBox = styled.div`
  background-color: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 16px;
  padding: 1.5rem 2rem;
  max-width: 896px;
  width: 100%;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    padding: 1.5rem;
  }
`;

export const SeoText = styled.p`
  && {
    color: #2c1600;
    font-size: 16px;
    line-height: 1.5;
    margin: 0;
    text-align: left;
    font-weight: 400;

    &:not(:last-child) {
      margin-bottom: 0.5rem;
    }

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  width: 100%;
  max-width: 768px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  resize: none;
  height: 176px;
  border: none;
  background-color: #f8f9fa;
  border-radius: 24px;
  padding: 2rem;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  color: ${Colors.accent1};

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${Colors.accent2}33;
  }
`;

export const SubmitButton = styled.button`
  display: flex;
  align-self: center;
  align-items: center;
  gap: 0.5rem;
  background-color: ${Colors.accent2};
  color: white;
  border: none;
  font-size: 20px;
  font-weight: 400;
  padding: 0.5rem 3rem;
  border-radius: 999px;
  font-family: "Roboto", sans-serif;
  cursor: pointer;
  transition:
    transform 0.2s,
    background-color 0.2s;

  &:hover {
    background-color: #c66d03;
    transform: translateY(-1px);
  }

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const ReviewsGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 24px;
  width: 100%;
  padding-top: 2rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 600px) {
    gap: 16px;
    padding-top: 1rem;
  }
`;

export const ReviewCard = styled.article`
  background: white;
  border: 1px solid #f3f4f6;
  border-radius: 24px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  grid-column: span 3;

  ${({ isLarge }) => isLarge && "grid-column: span 6;"}
  ${({ isTall }) => isTall && "grid-row: span 2;"}

  @media (max-width: 1024px) {
    grid-column: span 1;
    ${({ isLarge }) => isLarge && "grid-column: span 2;"}
    ${({ isTall }) => isTall && "grid-row: span 1;"}
  }

  @media (max-width: 640px) {
    grid-column: span 1 !important;
    grid-row: span 1 !important;
  }

  @media (max-width: 600px) {
    padding: 20px;
    gap: 12px;
  }
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: rgba(230, 126, 0, 0.08);
  padding: 4px 10px;
  border-radius: 999px;
  align-self: flex-start;
`;

export const StarIcon = styled.img`
  width: 12px;
  height: 12px;
`;

export const BadgeText = styled.span`
  color: #e67e00;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 12px;
`;

export const ReviewText = styled.p`
  && {
    color: ${({ isDark }) => (isDark ? "#2c1600" : "#374151")};
    font-family:
      ${({ isDark }) => (isDark ? "'Plus Jakarta Sans'" : "'Inter'")},
      sans-serif;
    font-weight: ${({ isDark }) => (isDark ? "700" : "400")};
    font-size: ${({ isDark }) => (isDark ? "18px" : "14px")};
    line-height: ${({ isDark }) => (isDark ? "1.5" : "1.6")};
    margin: 0;
  }
`;
